import React, { Suspense, useEffect } from "react"
import { useDispatch } from "react-redux"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import ProtectedRoute from "./components/ProtectedRoute"
import { ThemeProvider } from "./context/ThemeProvider"
import { initializeAuth } from "./slices/user_management_slice"

const Home = React.lazy(() => import("./views/pages/Home/Home"))
const SignIn = React.lazy(() => import("./views/pages/SignIn/SignIn"))
const TransportationServices = React.lazy(() =>
  import("./views/pages/TransportationServices/TransportationServices")
)
const Admin = React.lazy(() => import("./views/dashboards/Admin"))
const Ratings = React.lazy(() => import("./components/Ratings/Ratings"))
const Agent = React.lazy(() => import("./views/dashboards/Agent"))
const Individual = React.lazy(() => import("./views/dashboards/Individual"))
const Corporate = React.lazy(() => import("./views/dashboards/Corporate"))
const Driver = React.lazy(() => import("./views/dashboards/Driver"))
const Unauthorized = React.lazy(() => import("./views/pages/Unauthorized"))

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const AppRoutes = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(initializeAuth())
  }, [dispatch])

  return (
    <Routes>
      <Route exact path="/" name="KALE" element={<Home />} />
      <Route exact path="/signIn" name="Login" element={<SignIn />} />
      <Route
        exact
        path="/booking"
        name="Booking"
        element={<TransportationServices />}
      />
      <Route
        path="/dashboard/*"
        element={
          <ProtectedRoute requiredType={["ADMIN", "KALE"]}>
            <Admin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/ratings"
        element={
          <ProtectedRoute
            requiredType={[
              "ADMIN",
              "KALE",
              "AGENT",
              "INDIVIDUAL",
              "CORPORATE",
              "DRIVER"
            ]}
          >
            <Ratings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/agent/*"
        element={
          <ProtectedRoute requiredType="AGENT">
            <Agent />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/individual/*"
        element={
          <ProtectedRoute requiredType="INDIVIDUAL">
            <Individual />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/corporate/*"
        element={
          <ProtectedRoute requiredType="CORPORATE">
            <Corporate />
          </ProtectedRoute>
        }
      />

      <Route
        path="/dashboard/driver/*"
        element={
          <ProtectedRoute requiredType="DRIVER">
            <Driver />
          </ProtectedRoute>
        }
      />
      <Route path="/unauthorized" element={<Unauthorized />} />
    </Routes>
  )
}

const App = () => {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Suspense fallback={loading}>
          <AppRoutes />
        </Suspense>
      </BrowserRouter>
      <ToastContainer />
    </ThemeProvider>
  )
}

export default App
